
//WEEKS LIST
export const WeeksList = ()=>{
    return(
        [
            {
              label: 'Sun',
              value: 1,
              
            },
            {
              label: 'Mon',
              value: 2,
              
            },
            {
              label: 'Tue',
              value: 4,
              
            },
            {
              label: 'Wed',
              value: 8,
              
            },
            {
              label: 'Thu',
              value: 16,
              
            },
            {
              label: 'Fri',
              value: 32,
              
            },
            {
              label: 'Sat',
              value: 64,
              
            }
          ]
    )
}

// WEEKS SEQUENCE LIST
export const WeeksSequenceList = ()=>{
    return(
        [
            {
              label: 'First',
              value: 0,
              
            },
            {
              label: 'Second',
              value: 1,
              
            },
            {
              label: 'Third',
              value: 2,
              
            },
            {
              label: 'Fourth',
              value: 3,
              
            },
            {
              label: 'Last',
              value: 4,
              
            }
          ]
    )
}

// 
export const MonthsList = ()=>{
    return(
        [
            {
              label: 'Jan',
              value: 0,
              
            },
            {
              label: 'Feb',
              value: 1,
              
            },
            {
              label: 'Mar',
              value: 2,
              
            },
            {
              label: 'Apr',
              value: 3,
              
            },
            {
              label: 'May',
              value: 4,
              
            },
            {
              label: 'Jun',
              value: 5,
              
            },
            {
              label: 'Jul',
              value: 6,
              
            },
            {
              label: 'Aug',
              value: 7,
              
            },
            {
              label: 'Sep',
              value: 8,
              
            },
            {
              label: 'Oct',
              value: 9,
              
            },
            {
              label: 'Nov',
              value: 10,
              
            },
            {
              label: 'Dec',
              value: 11,
              
            }
          ]
    )
}

// DAYS LIST
export const MonthDaysList = ()=>{
    let daysArr = [];
    for(let i=1;i<=31;i++){
        daysArr.push({
            label:i,
            value:i
        });
    }
    return daysArr;
}